import React from "react";
import {
  fetchCartProducts,
  fetchCustomShippingMethods,
  setSelectedShippingAddress,
  setLoaderCheckout,
  setLoader,
  fetchSeller,
  setUpdateProductDetails,
  disableCheckoutButton,
  removeProductFromCart,
  enableCheckoutButton,
  removeGiftCardDetailsByCartItemId,
} from "../actions";
import { connect } from "react-redux";
import history from "../history";
import { Link } from "react-router-dom";

window.update_qty_timeouts = {};

class CheckoutCart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showQtyButtonsIndex: false,
    };
  }
  componentDidMount = () => {
    if (this.props.auth.is_signed_in) {
      // Cart is now localStorage-based, mark as ready immediately
      this.props.setLoaderCheckout("cart");

      // Fetch cart products from localStorage
      this.props.fetchCartProducts((num_products) => {
        this.props.setLoaderCheckout("cart_products");
        if (num_products === 0) {
          this.props.setLoader(false, null);
          history.push("/browse");
        } else {
          // Set up shipping address and fetch shipping methods
          this.setCartAndShippingAddress();

          // Fetch seller info if not autologin
          if (!this.props.autologin_product_id) {
            if (this.props.cart_products.items.length > 0) {
              this.props.fetchSeller(this.props.cart_products.items[0].id, () => {
                this.props.setLoaderCheckout("seller");
              });
            } else {
              this.props.setLoaderCheckout("seller");
            }
          }
        }
      });
    }
  };

  setCartAndShippingAddress = () => {
    console.log("setCartAndShippingAddress - cart items:", this.props.cart_products);

    // Get shipping address from localStorage
    const savedShippingAddress = JSON.parse(localStorage.getItem("selectedShippingAddress") || "null");
    const savedAddresses = JSON.parse(localStorage.getItem("shippingAddresses") || "[]");

    // Set shipping address from localStorage if available
    if (savedShippingAddress) {
      this.props.setSelectedShippingAddress(savedShippingAddress, savedAddresses);
    }

    // Fetch shipping methods - use seller_id from first cart item
    const cartItems = this.props.cart_products?.items || [];
    if (cartItems.length > 0 && cartItems[0].seller_id) {
      this.props.fetchCustomShippingMethods(cartItems[0].seller_id);
    }

    this.props.setLoader(false);
  };

  componentDidUpdate = () => {
    if (this.props.cart_products.items.length === 0) {
      history.push("/browse");
    }
  };

  updateProductQty = (product, qty) => {
    if (window.update_qty_timeouts[product.cart_item]) {
      clearTimeout(window.update_qty_timeouts[product.cart_item]);
    }
    window.update_qty_timeouts[product.cart_item] = setTimeout(() => {
      this.props.setLoader(true, "Updating Product Qty...");

      // Update quantity directly in localStorage
      const cartItems = JSON.parse(localStorage.getItem("cartItems") || "[]");
      const itemIndex = cartItems.findIndex(item =>
        item.cart_item === product.cart_item || item.id === product.id || item.sku === product.sku
      );

      if (itemIndex !== -1) {
        if (qty <= 0) {
          // Remove item if qty is 0 or less
          cartItems.splice(itemIndex, 1);
        } else {
          // Update quantity
          cartItems[itemIndex].qty = qty;
        }
        localStorage.setItem("cartItems", JSON.stringify(cartItems));
      }

      // Refresh cart products from localStorage
      this.props.fetchCartProducts(() => {
        this.props.setLoader(false, null);
        this.props.enableCheckoutButton();
        this.setState({ showQtyButtonsIndex: null });
      });
    }, 500);
  };

  renderCartProducts = () => {
    let total = 0;
    let totals = null;
    let totals_added = false;

    const items = this.props.cart_products.items.map((v, i, a) => {
      const price_dec = parseFloat(v.price);
      total += v.qty * price_dec;

      const price = price_dec.toFixed(2);

      let short_desc = v.short_desc ? v.short_desc : null;
      if (short_desc) {
        short_desc = short_desc.substring(3, short_desc.lastIndexOf("<"));
        if (short_desc.length > 20) {
          short_desc = short_desc.substr(0, 20) + "...";
        }
      }

      let image =
        v.images.length > 0
          ? v.images[0]
          : "https://staging.securemobile.net/pub/static/frontend/Codazon/fastest_bigmarket/en_AU/Magento_Catalog/images/product/placeholder/thumbnail.jpg";

      if (i === a.length - 1) {
        let shipping_amount = "...";
        if (this.props.shipping_method) {
          shipping_amount = this.props.shipping_method.amount;
          total += shipping_amount;
          shipping_amount = shipping_amount.toFixed(2);
        }

        let total_amount = total.toFixed(2);

        totals = (
          <React.Fragment>
            <div id="checkout-delivery-row" className="checkout-row-clear">
              <div className="checkout-delivery-total">Delivery</div>{" "}
              <div
                id="checkout-delivery-price"
                className="checkout-delivery-total-right"
              >
                ${shipping_amount}
              </div>
            </div>
            <div id="checkout-total-row" className="checkout-row-clear">
              <div
                id="checkout-delivery-total-text"
                className="checkout-delivery-total"
              >
                Total
              </div>{" "}
              <div
                id="checkout-order-total"
                className="checkout-delivery-total-right"
              >
                ${total_amount}
              </div>
            </div>
          </React.Fragment>
        );

        if (!v.is_giftcard) {
          totals_added = true;
        }
      }

      let configurable_options = null;
      if (v.product_option) {
        configurable_options = v.product_option.extension_attributes.configurable_item_options.map((v) => {
          return (
              <div key={v.value_index} class="checkout-normal">
                {v.option_label}: {v.option_title}
              </div>
          );
        });
      }

      return (
        <div key={v.item_id} className="checkout-product">
          <div className="clear">
            <div className="checkout-left-col">
              <div className="checkout-bold-left">{v.name}</div>
              <div className="checkout-normal">{short_desc}</div>
              {configurable_options}
              <div className="checkout-bold" style={{ marginBottom: 9 }}>
                ${price}
              </div>
              <div className="checkout-qty">
                Qty <span className="checkout-qty-number">{v.qty}</span>
              </div>
              {!v.is_giftcard && totals}
            </div>
            <div className="checkout-right-col">
              <img
                className={
                  v.is_giftcard ? "checkout-giftcard-image" : "checkout-image"
                }
                src={image}
              />
            </div>
          </div>
        </div>
      );
    });

    return (
      <div>
        <div>{items}</div>
        {!totals_added && totals}
      </div>
    );
  };

  render() {
    return <div id="checkout-cart">{this.renderCartProducts()}</div>;
  }
}

const mapStateToProps = (state) => {
  return {
    shipping_method: state.shipping_method.shipping_method,
    cart_products: state.cart_products.cart_products,
    shipping_addresses: state.shipping_addresses,
    autologin_product_id: state.autologin_product,
    auth: state.auth,
    gift_card_details: state.gift_card_details.gift_card_details,
  };
};

export default connect(mapStateToProps, {
  fetchCartProducts,
  fetchCustomShippingMethods,
  setSelectedShippingAddress,
  setLoaderCheckout,
  setLoader,
  fetchSeller,
  setUpdateProductDetails,
  disableCheckoutButton,
  removeProductFromCart,
  enableCheckoutButton,
  removeGiftCardDetailsByCartItemId,
})(CheckoutCart);
